
export class FiltroItem {
  idFiltroItens?: number;
  idFiltro?: number;
  usuarioCriacao: string;
  responsavel: string;
}
